<template>
  <div>
    <el-card class="mtf-head">
      <div class="custom-flex-space-between">
        <div class="curMonth">
          <el-radio-group v-model="timeDimension" @change="changeTimeDimension"  class="custom-elRadioGroup" text-color="#78bfcf" fill="#ffffff">
            <el-radio-button label="Month" >{{ $t('DomesticWarehousing.CurrentMonth') }}</el-radio-button>
            <el-radio-button label="Season" >{{ $t('DomesticWarehousing.CurrentQuarter') }}</el-radio-button>
            <el-radio-button label="Year" >{{ $t('DomesticWarehousing.CurrentYear') }}</el-radio-button>
          </el-radio-group>
        </div >
        <div class='curDateStr' style="float:left;" >
          <div style="float:left; line-height: 30px;" >{{ $t('DomesticWarehousing.Date') }}：</div>
          <div style="float:left;" >
            <el-date-picker class='datebox'
            format='yyyy-MM'
            value-format='yyyy-MM'
            type='month'
            :placeholder="$t('DomesticWarehousing.PleaseSelectDate')"
            v-model="dateStr"
            @change="changeDate"
          ></el-date-picker>
          </div>
        </div>
      </div>
      <el-divider />
    </el-card>
    <div style="">
      <el-card class="mtf-head">
        <el-row :gutter="20">
          <el-col v-loading="inOutTicketLoading" :span="6">
            <div class="accumulatedL custom-flex-space-between borderRadius" style="background: #62befc;padding-right:20px;padding: 5px 20px 5px 5px;">
              <div style="margin-top:10px;" >
                <p class="ocean-label">{{ $t('DomesticWarehousing.InOutQty') }}</p>
                <div class="ocean-content">{{ $t('DomesticWarehousing.Inbound') + '：'+ inOutTicketData.inQty }}</div>
                <div class="ocean-content">{{ $t('DomesticWarehousing.Outbound') + '：'+ inOutTicketData.outQty  }}</div>
              </div>
              <img src="@/assets/wms/inStore.png" style="width: 100px;height: 70px;">
            </div>
          </el-col>
          <el-col v-loading="inOutTonneLoading" :span="6">
            <div class="accumulatedL custom-flex-space-between borderRadius" style="background: #f6d5d9;padding: 5px 20px 5px 5px;">
              <div style="margin-top:10px;" >
                <p class="ocean-label">{{$t('DomesticWarehousing.InTonsQty')}}</p>
                <div class="ocean-content">{{ $t('DomesticWarehousing.Inbound') + '：' + inOutTonneData.inQty  }}</div>
                <div class="ocean-content">{{ $t('DomesticWarehousing.Outbound') + '：' + inOutTonneData.outQty  }}</div>
              </div>
              <img src="@/assets/wms/outStore.png" style="width: 70px;height: 70px;">
            </div>
          </el-col>
          <el-col v-loading="currentStockTonneLoading" :span="6">
            <div class="accumulatedL custom-flex-space-between borderRadius" style="background: #affcfc;padding-right:20px;padding: 5px 20px 5px 5px;">
              <div style="margin-top:10px;" >
                <p class="ocean-label">{{ $t('DomesticWarehousing.RealTimeStock') }}</p>
                <div class="ocean-content">{{ currentTonneStockData.currentQty }}</div>
              </div>
              <img src="@/assets/wms/inventory.png" style="width: 80px;height: 70px;">
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-card v-loading="inOutTicketChartLoading" class="mt10">
            <BarChart v-if="showMileageEchart" id="inOutTicketChart" ref="inOutTicketChart" />
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card v-loading="inOutTonneChartLoading" class="mt10 minheight280">
            <BarChart v-if="showMileageEchart" id="inOutTonneChart" ref="inOutTonneChart" />
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card v-loading="stockTonneChartLoading" class="mt10 minheight280">
            <BarChart v-if="showMileageEchart" id="stockTonneChart" ref="stockTonneChart" />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import BarChart from '@/components/wms/barChart'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getInOutTicketStatisticApi, getInOutTonneStatisticApi, getCurrentTonneStockStaticApi, getInOutTicketBarDataApi, getInOutTonneBarDataApi, getTonneStockBarDataApi } from '@/api/wms'
export default {
  components: {
    BarChart, ElImageViewer
  },
  props: {
    jobType: {
      type: String,
      default: 'DC'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {},
      inOutTicketData: {},
      inOutTonneData: {},
      currentTonneStockData: {},
      /** 周期 */
      timeDimension: 'Month',
      showMileageEchart: true,
      inOutTicketLoading: true,
      inOutTonneLoading: true,
      currentStockTonneLoading: true,
      inOutTicketChartLoading: true,
      inOutTonneChartLoading: true,
      stockTonneChartLoading: true,
      dateStr: '',
      lang: 'zh',
    }
  },
  computed: {},
  // watch: {
  //   timeDimension(newValue, oldValue) {
  //     if (newValue !== oldValue) {
  //       this.dateStr = ''
  //       this.init()
  //     }
  //   }
  // },
  mounted() {
    this.lang = this.$ls.get('lang');
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    this.dateStr = `${year}-${month}`;
    this.init();
  },
  methods: {
    handleChange() {
      this.$emit('update:jobType', this.circuitSelect)
    },
    changeDate(val) {      
      this.init()
    },
    changeTimeDimension(){      
      this.init()
    },
    init() {
      this.getInOutTicketStatistics()
      this.getInOutTonneStatistics()
      this.getCurrentTonneStockStatics()
      this.getInOutTicketBarData()
      this.getInOutTonneBarData()
      this.getTonneStockBarData()
    },
    async getInOutTicketStatistics() {
      this.inOutTicketLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr }
      console.log(params)
      var res = await getInOutTicketStatisticApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.inOutTicketData = data
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.inOutTicketLoading = false
    },
    async getInOutTonneStatistics() {
      this.inOutTonneLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr
      
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr }
      var res = await getInOutTonneStatisticApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.inOutTonneData = data
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.inOutTonneLoading = false
    },
    async getCurrentTonneStockStatics() {
      this.currentStockTonneLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr
      
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr }
      var res = await getCurrentTonneStockStaticApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.currentTonneStockData = data
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.currentStockTonneLoading = false
    },
    async getInOutTicketBarData() {
      this.inOutTicketChartLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr
      
      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getInOutTicketBarDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        // this.currentTonneStockData = data
        this.$refs.inOutTicketChart.chartInit(data);
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.inOutTicketChartLoading = false
    },
    async getInOutTonneBarData() {
      this.inOutTonneChartLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getInOutTonneBarDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        // this.currentTonneStockData = data
        this.$refs.inOutTonneChart.chartInit(data);
      } else {
        this.messagebox.alert('查询失败，Query failure ')
      }
      this.inOutTonneChartLoading = false
    },
    async getTonneStockBarData() {
      this.stockTonneChartLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getTonneStockBarDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        // this.currentTonneStockData = data
        this.$refs.stockTonneChart.chartInit(data);
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.stockTonneChartLoading = false
    },
  }
}
</script>
<style scoped>
/* 公共样式提取至内部 开始*/
.custom-input {
  border: none;
  width: 200px;
}
.custom-input >>> input {
  border: none;
  background: #f6f6f8;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head >>> .el-card__body {
  padding: 0px 20px 0px 20px !important;
  margin-bottom: 20px;
}

.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.minheight280 {
  min-height: 280px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dian::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 4px 4px;
  background: #f6f6f8;
}
.curDateStr {
  padding: 4px 4px;
  margin-top: 10px;
}
.elSelect {
  width: 180px;
  margin-left: 10px;
  border-radius: 8px;
}

.accumulatedL,
.accumulatedR {
  padding-left: 24px;
}
.ocean-label{
  font-size: 15px;
  font-weight: 400;
  color: #4b5563;
}
.ocean-content{
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 5px 0 0 0px;
}
>>>.el-input__inner,
>>> .el-input__prefix,
>>> .el-input__icon {
  line-height: 30px;
  height: 30px;
}
</style>
